// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"551":"b0ffe9f2","679":"efc3cab6"}[chunkId] + ".chunk.js";
};